document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('a[smooth-scroll]')

    for (let anchor of anchors) {
        anchor.addEventListener('click', function (e) {
            try {
                e.preventDefault()

                const id = anchor.getAttribute('href').split('#').pop()

                document.getElementById(id).scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                })

                history.pushState(null, null, '#' + id)
            } catch (error) {
                console.error(error)
            }
        })
    }
})
